import { BaseComment } from '../../base/base-comment';
import { BaseCommentRequest } from '../../base/base-comment-request';
import { CommentMention } from '../../base/comment-mention';
import { InternalUser } from './internal-user';

export class MemberDeathRecordComment extends BaseComment {
  public deathRecordId!: number;
  public mentions: CommentMention[] = [];

  onDeserialize(): void {
    super.onDeserialize();
    if (this.author) {
      this.author = window.injector.Deserialize.instanceOf(InternalUser, this.author);
    }
  }
}

export class MemberDeathRecordCommentRequest extends BaseCommentRequest {
  public deathRecordId!: number;
}
